import React, { useState } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";

export const TableCheckThongTinKh = ({ data }) => {
  const [pageNumber, setpageNumber] = useState(1);

  const handlePageChange = (pageNumber) => {
    setpageNumber(pageNumber);
    alert(data.code);
  };
  const TotalQuantity = 15;
  /*
  const dataSearch = {
    dateFrom: "01/01/2001",
    dateTo: "01/01/4000",
    code: "",
    customerName: "",
    address: "",
    noteTaiSan: "",
    status: "5",
    debt: "-1",
    userName: "",
    pageIndex: 1,
    pageSize: 20,
    ThoiGian: "",
  };*/
  return (
    <div className="Left808x200 Table-main-new">
      <div className="table-mobile ">
        <div className="custom-table-wrapper">
          <div className="table-headers">
            <div className="custom-table-header flex-basis-16 flex-basis-15-6-sm">
              <p className="text-left">Tên khách hàng</p>
            </div>
            <div className="custom-table-header flex-basis-12 flex-basis-11-8-sm">
              <p className="text-left">Số CCCD</p>
            </div>
            <div className="custom-table-header flex-basis-13 flex-basis-12-sm">
              <p className="text-left">Tên cửa hàng</p>
            </div>
            <div className="custom-table-header flex-basis-17 flex-basis-20-6-sm">
              <p className="text-left">Địa chỉ</p>
            </div>
            <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
              <p className="text-center">Kiểu vay</p>
            </div>
            <div className="custom-table-header flex-basis-11 flex-basis-8-sm">
              <p className="text-right">Số tiền vay</p>
            </div>
            <div className="custom-table-header flex-basis-10 flex-basis-11-sm">
              <p className="tab-header text-center">Tình trạng</p>
            </div>
            <div className="custom-table-header flex-basis-10 flex-basis-8-sm">
              <p className="tab-header  text-center">Trạng thái</p>
            </div>
          </div>

          <div className="custom-table-body">
            <ContentTable />
          </div>
        </div>
      </div>
      <div
        className={
          "paniation-new paniation-new1 d-flex justify-content-center " +
          (TotalQuantity === 0 ? "hidden" : "")
        }
      >
        <nav aria-label="Page navigation">
          <Pagination
            activePage={data.pageIndex}
            itemsCountPerPage={data.pageSize}
            totalItemsCount={TotalQuantity}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link"
            activeClass="active"
          />
        </nav>
      </div>
    </div>
  );
};
